<header class="eq-barra-superior">
  <div class="eq-barra-superior__izquierda">
    <button
      type="button"
      class="eq-barra-superior__btn-menu"
      [attr.aria-label]="t().barraSuperior.abrirMenu"
      (click)="alternarMenuLateral()"
    >
      <i class="pi pi-bars"></i>
    </button>

    <button
      type="button"
      class="eq-barra-superior__logo"
      [attr.aria-label]="t().barraSuperior.irAlInicio"
      (click)="irAlInicio()"
    >
      <i class="pi pi-home" aria-hidden="true"></i>
    </button>

    <div class="eq-barra-superior__nombre-sistema">
      <i class="pi pi-briefcase eq-barra-superior__nombre-sistema-icono"></i>
      <span class="eq-barra-superior__nombre-sistema-texto">{{ nombreAplicacion }}</span>
    </div>
  </div>

  <div class="eq-barra-superior__acciones">
    <app-selector-conjunto class="eq-barra-superior__conjunto" />
    <app-selector-idioma class="eq-barra-superior__idioma" />
    <app-campana-avisos />
    <div class="eq-barra-superior__perfil-contenedor" #contenedorMenuUsuario>
      <button
        type="button"
        class="eq-barra-superior__perfil"
        [attr.aria-expanded]="menuUsuarioAbierto()"
        aria-haspopup="menu"
        (click)="alternarMenuUsuario()"
      >
        <p-avatar
          [label]="nombreUsuario() | iniciales"
          shape="circle"
          styleClass="eq-avatar-marca"
        />
        <span class="eq-barra-superior__perfil-info">
          <span class="eq-barra-superior__perfil-nombre">{{ nombreUsuario() }}</span>
          <span class="eq-barra-superior__perfil-puesto">{{ cargoUsuario() }}</span>
        </span>
        <i class="pi pi-chevron-down eq-barra-superior__perfil-chevron"></i>
      </button>

      @if (menuUsuarioAbierto()) {
        <div class="eq-barra-superior__menu-usuario" role="menu">
          @for (opcion of opcionesMenuUsuario(); track opcion.identificador; let ultimo = $last) {
            @if (ultimo) {
              <div class="eq-barra-superior__menu-usuario-separador"></div>
            }
            <button
              type="button"
              class="eq-barra-superior__menu-usuario-item"
              role="menuitem"
              (click)="seleccionarOpcion(opcion)"
            >
              <i [class]="opcion.icono"></i>
              <span>{{ opcion.etiqueta }}</span>
            </button>
          }
        </div>
      }
    </div>
  </div>
</header>
